export const TICKS_HEIGHT = 48;
